<template>
    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col>
                <div class="pa-2 rounded elevation-1 bg-white">
                    <SportipsButton backButton chevronLeft>Retour</SportipsButton>
                    <div class="text-h6 font-weight-bold mt-3 mb-2">Configuration du dashboard</div>
                    <div class="text-body-2 text-medium-emphasis mb-4">
                        Masquez ou affichez les actions visibles par l'organisateur sur le dashboard.
                    </div>

                    <v-progress-linear v-if="loading" indeterminate color="primary-dark" class="mb-4" />

                    <v-alert v-if="loadError" type="error" variant="tonal" class="mb-4" density="compact">
                        Impossible de charger la configuration du dashboard.
                    </v-alert>

                    <div v-else class="d-flex flex-column ga-2">
                        <div v-for="action in actions" :key="action.key"
                            class="d-flex align-center justify-space-between flex-wrap ga-2 pa-3 rounded action-row"
                            :class="{ 'action-row--hidden': isHidden(action.key) }">
                            <div class="flex-grow-1 ">
                                <div class="d-flex align-center ga-2">
                                    <v-chip v-if="isHidden(action.key)" color="red-darken-4" variant="elevated"
                                        elevation="0" size="small">Masquée</v-chip>
                                    <div class="font-weight-bold">{{ action.label }}

                                    </div>

                                </div>
                                <div>{{ action.subtitle }}</div>

                            </div>
                            <div class="d-flex align-center ga-2">

                                <SportipsButton @click="toggleAction(action.key)"
                                    :icon="isHidden(action.key) ? 'mdi-eye' : 'mdi-eye-off'">{{ isHidden(action.key) ?
                                        'Afficher' :
                                        'Masquer' }}</SportipsButton>

                            </div>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useDashboardConfigStore, DASHBOARD_ACTIONS } from "@/stores/dashboardConfigStore";

export default {
    data() {
        return {
            actions: DASHBOARD_ACTIONS,
            loading: false,
            loadError: false,
            pendingKey: null,
        };
    },
    computed: {
        ...mapStores(useMainStore, useDashboardConfigStore),
    },
    async mounted() {
        await this.loadConfig();
    },
    methods: {
        isHidden(key) {
            return this.dashboardConfigStore.isHidden(key);
        },
        async loadConfig() {
            this.loading = true;
            this.loadError = false;
            const id_module = this.mainStore.module.id;
            const ok = await this.dashboardConfigStore.fetch(id_module);
            this.loadError = !ok;
            this.loading = false;
        },
        async toggleAction(key) {
            this.pendingKey = key;
            const ok = await this.dashboardConfigStore.toggle(key);
            this.pendingKey = null;
            if (!ok) {
                this.mainStore.notification.send(
                    "Impossible de mettre à jour la configuration.",
                    "error"
                );
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.action-row {
    background: #f5f5f5;
    border: 1px solid transparent;
}

.action-row--hidden {
    opacity: 0.7;
    border-color: rgba(0, 0, 0, 0.08);
}
</style>
